import { CreateRenderFunction } from "@pdfking/reactivity/preact"
import { Range } from "@pdfking/tfunc"
import { Icon } from "@pdfking/workflow/components/Icon"

export const Rating = CreateRenderFunction({
  computed: { range: () => [...Range(2, 10, 2)] },
  data: {
    local: 0,
  },
  init() {
    this.local = this.value
  },
  props: {
    name: "",
    value: 0,
  },
  render() {
    return (
      <div class="rating-widget">
        <input name={this.name} type="hidden" value={this.local} />
        {this.range.map((i: number) => (
          <span
            key={i}
            onClick={() => {
              this.local = i
            }}
            style="cursor: pointer"
          >
            <Icon name={i <= this.local ? "STAR" : "STAR_EMPTY"} />
          </span>
        ))}
      </div>
    )
  },
})
